import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class AutorizarNovoDispositivoService {

  constructor(
    private httpService: HttpService
  ) { }
 
  returnMobileAccess(data:any, successHandle:Function, errorHandle:Function){
    return this.httpService.doGet('/mobileAccess/returnMobileAccess',data,successHandle, errorHandle);
  }

  updateMobileAccess(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doPost('/mobileAccess/updateMobileAccess', data, successHandle, errorHandle);

  }

}
